// src/store/bottomSheet.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { SheetProps } from '@/types/Sheet';

export const useBottomSheetStore = defineStore('bottomSheet', () => {
  const isOpen = ref(false);
  const formTitle = ref<string | null>(null);
  const module = ref<string | null>(null);  // útil para mostrar contexto dinámico
  const props = ref<SheetProps | null>(null); // contiene: item, action, message, etc.

  const openSheet = (options: {
    module?: string;
    formTitle?: string;
    props?: SheetProps;
  }) => {
    module.value = options.module ?? null;
    formTitle.value = options.formTitle ?? null;
    props.value = options.props ?? null;
    isOpen.value = true;
  };

  const closeSheet = () => {
    isOpen.value = false;
    formTitle.value = null;
    module.value = null;
    props.value = null;
  };

  return {
    isOpen,
    openSheet,
    closeSheet,
    formTitle,
    module,
    props,
  };
});
